export enum HlsStatsReporterEvent {
	FRAG_REPORTED = 'fragReported',
	LEVEL_REPORTED = 'levelReported'
}
